import {
  useGetLanguageComplianceReportQuery,
  usePostLanguageComplianceUpdateStateMutation,
} from '../../../../app/api'
import { Preloader } from '../../../../shared/components/cards/preloader/Preloader'
import React from 'react'
import { BpAnchor } from '../../../../shared/components/text/anchor/BpAnchor'
import { BpButton } from '../../../../shared/components/buttons/bp-button/BpButton'
import { selectLanguageComplianceFilter } from '../../model/languageComplianceSlice'
import { useDispatch } from 'react-redux'
import { useAppSelector } from '../../../../app/store/hooks/Redux'
import { ILanguageComplianceFilter } from '../../model/types/LanguageComplianceFilter.interface'
import { hideModal, showAlert } from '../../../../app/store/reducers/AppSlice'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import styles from './LanguageComplianceReport.module.scss'

interface LanguageCompilianceReportProps {
  id: string
  state: string
  url: string
}

export const LanguageComplianceReport = ({ id, state, url }: LanguageCompilianceReportProps) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { project, country } = useAppSelector<ILanguageComplianceFilter>(
    selectLanguageComplianceFilter,
  )

  const { data, isLoading, isFetching } = useGetLanguageComplianceReportQuery({ id })

  const [updateState] = usePostLanguageComplianceUpdateStateMutation()

  if (isLoading || isFetching) {
    return (
      <div className={clsx(styles.preloaderWrapper)}>
        <Preloader />
      </div>
    )
  }

  return (
    <div className={clsx(styles.root)}>
      <div className={clsx(styles.header)}>
        <h3 className={clsx(styles.title)}>
          <span className={clsx(styles.titleText)}>Report {data?.data?.created_at}</span>
        </h3>
        <BpAnchor className={clsx(styles.anchor)} href={data?.data?.url} target={'_blank'}>
          {data?.data?.url?.replace(/^(http:\/\/|https:\/\/)?(www\.)?/, '')}
        </BpAnchor>
        <span className={clsx(styles.meta)}>
          {data?.data?.country} | {data?.data?.device}
        </span>
        <div className={clsx(styles.actionsRow)}>
          {
            {
              last_check: (
                <BpButton
                  size={'sm'}
                  onClick={() => {
                    updateState({
                      stateForm: {
                        project_id: Number(project),
                        country_id: country,
                        urls: [url],
                        state: 'in_progress',
                      },
                    }).then(() => {
                      dispatch(
                        showAlert({
                          message: t('notifications.reportMoved'),
                          type: 'success',
                          timeout: 2000,
                        }),
                      )
                    })
                    dispatch(hideModal())
                  }}
                >
                  Move to In progress
                </BpButton>
              ),
              in_progress: (
                <BpButton
                  size={'sm'}
                  onClick={() => {
                    updateState({
                      stateForm: {
                        project_id: Number(project),
                        country_id: country,
                        urls: [url],
                        state: 'resolved',
                      },
                    }).then(() => {
                      dispatch(
                        showAlert({
                          message: t('notifications.reportMoved'),
                          type: 'success',
                          timeout: 2000,
                        }),
                      )
                    })
                    dispatch(hideModal())
                  }}
                >
                  Resolve
                </BpButton>
              ),
            }[state]
          }
          <BpAnchor
            className={'bp-btn sm outline'}
            href={data?.data?.link_screen_url}
            target='_blank'
          >
            Page screenshot
          </BpAnchor>
        </div>
      </div>
      <div className={clsx(styles.content)}>
        {data?.data?.items?.map((row: string, index: number) => (
          <p
            key={index}
            className={clsx(styles.paragraph, 'mark-yellow')}
            dangerouslySetInnerHTML={{ __html: row }}
          />
        ))}
      </div>
    </div>
  )
}
